import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setRotaerrorIds } from "@/app_redux/reducers/slices/auth/rota_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IBadInventoryActionsPostBody, IBadInventoryActionsPostResponse } from "@/api_framework/api_modals/Inventory";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

AxiosCurlirize(axios, () => {});
type InventoryTaxCreateAPIResponse = { status: boolean; message: string };

export const useBadInventoryActionsAPI = (refreshCallback: () => void) => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (filterBody: IBadInventoryActionsPostBody) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: InventoryTaxCreateAPIResponse = await axios
          .post(`${INVENTORY_MODULE?.BAD_INVENTORY_ACTIONS?.baseURL}`, filterBody, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IBadInventoryActionsPostResponse>) => {
            if (res.data.status === true) {
              toast.success(res.data.message);
              refreshCallback();
              return { status: true, message: "batch" };
            } else {
              return { status: false, message: "product_not_filtered" };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);

            captureError(e);
            return { status: false, message: "product_not_filtered" };
          });
        return response;
      } catch (e: any) {
        // toast.error("Server Error: " + e.message);
      }
    },
    [dispatch, configuration.localStorage.ACCESS_TOKEN.key, refreshCallback],
  );

  return { execute };
};
